import axios from 'axios';
import Cookies from 'js-cookie';

// 创建独立实例，baseURL 指向 OpenAtom
const openAtomApi = axios.create({
  baseURL: 'https://api.openatom.tech',
  timeout: 10000,
  headers: {
    'Accept': 'application/json'
  }
});

// 添加专属拦截器（Token、错误处理等）
openAtomApi.interceptors.request.use(config => {
  const token = Cookies.get('accessToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    throw new Error('Cookie is missing.');
  }
  return config;
}, error => Promise.reject(error));

openAtomApi.interceptors.response.use(
  response => response,
  error => {
    return Promise.reject(error);
  }
);

export default openAtomApi;
